(ns manage.ad-variant.creation.content.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridColumnMenu useGridApiRef]]
            ["src/svg/arrows/arrow-down-to-line.svg$default" :as ArrowDownToLine]
            ["src/svg/inform/error-triangle-fill.svg$default" :as AlertIcon]
            ["src/svg/inform/plus.svg$default" :as Plus]
            ["src/svg/wpp/content-actions/edit.svg$default" :as Edit]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.set :as set]
            [common.flags :refer [use-flag]]
            [common.localstorage :as localstorage]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.patterns.feed-import :as feed-patterns]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.util :as util]
            [common.widgets.data-grid :as dg]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.split-button :refer [split-button]]
            [manage.ad-variant.creation.content.columns :as c]
            [manage.ad-variant.creation.content.hooks :as h]
            [manage.ad-variant.creation.feed.modal]
            [manage.ad-variant.queries :as ad-variant.queries]
            [manage.content-variant-page.queries :as content-queries]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn combine-content-values [item]
  (merge item (->> (concat (:content-values item)
                           (:click-through item)
                           (vals (:ad-content-values item)))
                   (into {} (map (juxt :name :value))))))

(defmodal release-lock-confirmation :content/release-lock-confirmation
  [{:keys [take-over editing-user-name]}]
  ($ modal-v2
     {:title "Another user is currently editing"
      :icon ($ SvgIcon {:color "warning"}
               ($ AlertIcon))
      :footer ($ Stack {:direction "row" :gap 1}
                 ($ Button {:variant "text"
                            :sx #js {:color "text.primary"}
                            :onClick #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button {:variant "contained"
                            :color "warning"
                            :onClick #(do (rf/dispatch [:modal/close])
                                          (take-over))}
                    "Take over editing"))}
     ($ Stack {:sx #js {:width "450px"}}
        ($ :p (str "This table is currently being edited by " editing-user-name ". "
                   "If you take over, their changes might be lost.")))))

(def Toolbar
  (uix/as-react
   (fn [{:keys [advertiser-id feed-id
                user-is-editing? user-can-start-editing? editing-user-name
                allowed-to-save? discard-changes save-changes add-row]}]
     (let [content-editing-enabled? (use-flag :content-editing)
           {set-lock :mutate} (use-mutation (content-queries/put-inline-editing-lock-mutation advertiser-id feed-id))
           {delete-lock :mutate} (use-mutation (content-queries/delete-inline-editing-lock-mutation advertiser-id feed-id))
           {download-variants :mutate} (use-mutation (content-queries/download-content-variants advertiser-id feed-id))]
       ($ dg/grid-toolbar
          {:hide-quick-filter user-is-editing?}
          (if user-is-editing?
            ($ :<>
               ($ Button
                  {:startIcon ($ Plus)
                   :variant "contained"
                   :color "grey"
                   :onClick add-row}
                  "Add row")
               ($ Stack {:direction "row" :alignItems "center" :gap 1}
                  ($ Button
                     {:variant "contained"
                      :disabled (not allowed-to-save?)
                      :onClick save-changes}
                     "Update")
                  ($ Button
                     {:variant "contained"
                      :color "grey"
                      :onClick (fn []
                                 (delete-lock)
                                 (discard-changes))}
                     "Cancel")))
            ($ Stack {:direction "row" :alignItems "center" :gap 1}
               ($ feed-patterns/import-status-with-refresh)
               (when content-editing-enabled?
                 ($ Tooltip
                    {:title (str editing-user-name " is currently editing")
                     :placement "bottom"
                     :disableHoverListener user-can-start-editing?}
                    ($ :span
                       ($ Button
                          {:startIcon ($ Edit)
                           :variant "contained"
                           :color "grey"
                           :onClick (fn []
                                      (if user-can-start-editing?
                                        (set-lock)
                                        (rf/dispatch [:modal/open {:id :content/release-lock-confirmation
                                                                   :props {:take-over (fn []
                                                                                        (delete-lock)
                                                                                        (set-lock))
                                                                           :editing-user-name editing-user-name}}])))}
                          "Edit"))))
               ($ split-button
                  {:variant "contained"
                   :color "grey"
                   :icon ($ ArrowDownToLine)
                   :options [{:label "Download as CSV"
                              :onClick #(download-variants {:format "csv"})}
                             {:label "Download as JSON"
                              :onClick #(download-variants {:format "json"})}]}))))))))

(defmodal resize-images-modal :automation/resize-images
  [{:keys [resize-images field filters]}]
  (let [[width set-width] (uix/use-state nil)
        [height set-height] (uix/use-state nil)]
    ($ modal-v2
       {:title (str "Bulk re-size " field)
        :footer ($ Stack {:direction "row" :gap 1}
                   ($ Button
                      {:variant "text"
                       :onClick #(rf/dispatch [:modal/close])
                       :sx #js {:color "text.primary"}}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :disabled (some nil? [width height])
                       :onClick (fn []
                                  (resize-images {:key field
                                                  :width width
                                                  :height height
                                                  :muix-data-grid filters})
                                  (rf/dispatch [:modal/close]))}
                      "Bulk resize"))}
       ($ Stack {:direction "row" :gap 2}
          ($ form-field
             {:label "Width"
              :sx #js {:width "50%"}}
             ($ input
                {:value width
                 :inputProps #js {:min 1 :max 8000}
                 :autoFocus true
                 :type "number"
                 :onChange (fn [e]
                             (let [value (-> e .-target .-value int)]
                               (set-width (min value 8000))))}))
          ($ form-field
             {:label "Height"
              :sx #js {:width "50%"}}
             ($ input
                {:value height
                 :inputProps #js {:min 1 :max 8000}
                 :type "number"
                 :onChange (fn [e]
                             (let [value (-> e .-target .-value int)]
                               (set-height (min value 8000))))}))))))

(defmodal set-value-modal :automation/set-value
  [{:keys [set-value field filters]}]
  (let [[text set-text] (uix/use-state nil)]
    ($ modal-v2
       {:title (str "Bulk set value " field)
        :footer ($ Stack {:direction "row" :gap 1}
                   ($ Button
                      {:variant "text"
                       :onClick #(rf/dispatch [:modal/close])
                       :sx #js {:color "text.primary"}}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :disabled (nil? text)
                       :onClick (fn []
                                  (set-value {:key field
                                              :value text
                                              :muix-data-grid filters})
                                  (rf/dispatch [:modal/close]))}
                      "Set Text"))}
       ($ form-field
          {:label "Value"
           :sx #js {:width "100%"}}
          ($ input
             {:value text
              :autoFocus true
              :type "text"
              :onChange (fn [e]
                          (let [value (-> e .-target .-value)]
                            (set-text value)))})))))

(defui custom-column-menu [{:keys [^js colDef resize-images set-value user-is-editing? table-filter-fn] :as props}]
  (let [[filter-model _] (dg/use-filter-model)
        image-column? (= (.-placeholderType colDef) "image")
        text-column? (= (.-placeholderType colDef) "text")]
    ($ GridColumnMenu
       (cond-> (dissoc (->clj props) :resize-images :set-value :table-filter-fn :user-is-editing?)
         image-column?
         (merge {:slots #js {:bulkAction (uix/as-react
                                          (fn [props]
                                            ($ MenuItem (dissoc props :colDef)
                                               ($ ListItemIcon
                                                  ($ Icon {:color "default"} "aspect_ratio"))
                                               "Bulk re-size images")))}
                 :slotProps #js {:bulkAction #js {:displayOrder 1
                                                  :disabled (not user-is-editing?)
                                                  :onClick #(rf/dispatch [:modal/open {:id :automation/resize-images
                                                                                       :props {:resize-images resize-images
                                                                                               :filters (table-filter-fn filter-model)
                                                                                               :field (.-feedField colDef)}}])}}})
         text-column?
         (merge {:slots #js {:bulkAction (uix/as-react
                                          (fn [props]
                                            ($ MenuItem (dissoc props :colDef)
                                               ($ ListItemIcon
                                                  ($ Icon {:color "default"} "air-line-seat-flat-angled")) ; TODO
                                               "Set value")))}
                 :slotProps #js {:bulkAction #js {:displayOrder 1
                                                  :disabled (not user-is-editing?)
                                                  :onClick #(rf/dispatch [:modal/open {:id :automation/set-value
                                                                                       :props {:set-value set-value
                                                                                               :filters (table-filter-fn filter-model)
                                                                                               :field (.-feedField colDef)}}])}}})))))

(defui content-view []
  (let [api-ref (useGridApiRef)
        {:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {{feed-id :feedId} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))

        {:keys [user-is-editing? user-can-start-editing? editing-user-name]} (h/use-editing-lock {:advertiser-id advertiser-id
                                                                                                  :feed-id feed-id})

        {:keys [columns table-query-fn table-filter-fn content-id-field-name]} (h/use-content-data {:advertiser-id advertiser-id
                                                                                                    :feed-id feed-id
                                                                                                    :user-can-edit? user-is-editing?})

        {:keys [import-state]} (h/use-latest-import {:advertiser-id advertiser-id
                                                     :feed-id feed-id})

        initial-sort-model #js [#js {:field "import-transaction-id" :sort "asc"}
                                #js {:field "sequence-number" :sort "asc"}]

        transform-response-fn (uix/use-callback (fn [rows]
                                                  (->> rows
                                                       (map (comp combine-content-values ->clj))
                                                       ->js))
                                                [])

        {:keys [rows set-rows] :as server-table-props} (dg/use-server-table-props
                                                        {:table-query-fn table-query-fn
                                                         :transform-response-fn transform-response-fn
                                                         :initial-pagination-model #js {:page 0 :pageSize 100}
                                                         :initial-sort-model initial-sort-model})

        unsaved-changes-localstorage-key (uix/use-memo (fn []
                                                         (str "content/unsaved-changes" adset-id))
                                                       [adset-id])

        initial-diff (uix/use-memo (fn []
                                     (some-> (js/JSON.parse (js/localStorage.getItem unsaved-changes-localstorage-key))
                                             ->clj
                                             (update :delete set)))
                                   [unsaved-changes-localstorage-key])

        reset-localstorage (uix/use-callback (fn []
                                               (localstorage/remove! unsaved-changes-localstorage-key))
                                             [unsaved-changes-localstorage-key])

        update-localstorage (uix/use-callback (fn [diff]
                                                (localstorage/save! unsaved-changes-localstorage-key diff))
                                              [unsaved-changes-localstorage-key])

        {save-inline-editing :mutate} (use-mutation (content-queries/inline-editing-mutation advertiser-id feed-id))

        on-save (uix/use-callback (fn [diff]
                                    (let [diff* (update diff :add (fn [add]
                                                                    (mapv (fn [row]
                                                                            (-> row
                                                                                (dissoc :id :isNew)
                                                                                (set/rename-keys {:content-id content-id-field-name})
                                                                                util/filter-nils-map))
                                                                          add)))]
                                      (save-inline-editing diff*)
                                      (reset-localstorage)))
                                  [reset-localstorage save-inline-editing content-id-field-name])

        {:keys [save-changes discard-changes add-row delete-row update-diff diff] editing-props :props}
        (dg/use-editing {:api-ref api-ref
                         :initial-diff initial-diff
                         :pagination-model (:paginationModel server-table-props)
                         :loading (:loading server-table-props)
                         :user-is-editing? user-is-editing?
                         :on-update update-localstorage
                         :on-save on-save
                         :on-discard reset-localstorage
                         :set-rows set-rows})

        allowed-to-save? (uix/use-memo (fn []
                                         (and (some seq (vals diff))
                                              (every? (fn [row]
                                                        (-> (dissoc row :id :isNew)
                                                            util/filter-nils-map
                                                            seq))
                                                      (:add diff))))
                                       [diff])

        columns* (uix/use-memo (fn []
                                 (cond-> columns
                                   user-is-editing? (-> vec
                                                        (conj (c/action-column delete-row))
                                                        into-array)))
                               [columns user-is-editing? delete-row])

        {resize-images :mutate} (use-mutation
                                 (ad-variant.queries/resize-images
                                  {:advertiser-id advertiser-id
                                   :feed-id feed-id
                                   :on-success #(update-diff {:change %})}))
        {set-value :mutate} (use-mutation
                             (ad-variant.queries/set-value
                              {:advertiser-id advertiser-id
                               :feed-id feed-id
                               :on-success #(update-diff {:change %})}))]

    ($ Stack
       {:direction "column"
        :flex 1
        :spacing 1
        :sx #js {:overflow "hidden"}}

       ;; TODO: Does this work
       (when (= "running" import-state)
         ($ Alert
            {:severity "info"}
            ($ AlertTitle "Loading content")
            "Loading your content. This should only take a few moments."))

       ($ DataGridPremium
          (merge
           server-table-props
           editing-props
           {:apiRef api-ref
            :columns columns*

            :isCellEditable (fn [^js params]
                              ;; Content-id's are not editable, unless the row has been added.
                              (or (not= (.-field params) "content-id")
                                  (.. params -row -isNew)))
            :rows rows
            :disableRowSelectionOnClick true
            :getRowId (fn [row]
                        (.-id row))

            :initialState #js {:columns #js {:columnVisibilityModel #js {:import-transaction-id false}}
                               :pinnedColumns #js {:left #js ["sequence-number" "content-id" "template-dimensions"]
                                                   :right #js ["updated-at" "actions"]}
                               :sorting #js {:sortModel initial-sort-model}}

            :slots #js {:toolbar Toolbar
                        :columnMenu (uix/as-react
                                     (fn [props]
                                       ($ custom-column-menu props)))}
            :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                            :toolbar #js {:advertiser-id advertiser-id
                                          :feed-id feed-id
                                          :user-is-editing? user-is-editing?
                                          :user-can-start-editing? user-can-start-editing?
                                          :editing-user-name editing-user-name
                                          :discard-changes discard-changes
                                          :save-changes save-changes
                                          :add-row add-row
                                          :allowed-to-save? allowed-to-save?}
                            :columnMenu #js {:resize-images resize-images
                                             :set-value set-value
                                             :table-filter-fn table-filter-fn
                                             :user-is-editing? user-is-editing?}}
            :localeText #js {:toolbarQuickFilterPlaceholder "Search in identifier..."}

            :noWrap true})))))
